/**
 * Controls visibility of the branching UI (tab + footer branch switcher).
 *
 * Reads from window._env_.BRANCHING_VISIBLE (set in env-config.js):
 * - "true"                        → visible for all domains
 * - ""  / null / absent           → hidden for all domains
 * - "domain1,domain2"             → visible only for listed domains (workspaces)
 */
export function isBranchingUIEnabled(): boolean {
  const val = (window as unknown as Record<string, Record<string, string>>)._env_?.BRANCHING_VISIBLE;
  if (!val) return false;
  if (val === "true") return true;
  const allowedDomains = val.split(",").map((e: string) => e.trim().toLowerCase());
  const currentDomain = (window as unknown as Record<string, string>).currentDomain?.toLowerCase();
  return currentDomain ? allowedDomains.includes(currentDomain) : false;
}
